import React from 'react';
import { Tag, KIND } from 'baseui/tag';
import { capitalize } from '../utils/formatters';

const RISK_KIND_MAP: Record<string, string> = {
	critical: KIND.negative,
	high: KIND.warning,
	medium: KIND.accent,
	low: KIND.positive
};

interface RiskBadgeProps {
	level: string;
}

const RiskBadge: React.FC<RiskBadgeProps> = ({ level }) => {
	const kind = RISK_KIND_MAP[level?.toLowerCase()] || KIND.primary;

	return (
		<Tag closeable={false} kind={kind as any}>
			{capitalize(level)}
		</Tag>
	);
};

export default RiskBadge;
